module.exports = __webpack_public_path__ + "media/images/etyekilogo-apple-152x152-9742ce550f22fa6422d2a05a0c8e460c.png";